export const HomePage = () => {
  return (
    <section className="section section--home">
      <div className="panel">
        <h1>Craig Bojko</h1>
        <h2>Software Engineer</h2>
        <p>
          I'm a full-stack software engineer passionate about building scalable, user-centric applications. I specialize
          in modern web technologies and love solving complex problems with clean, maintainable code.
        </p>
      </div>
    </section>
  )
}
